module.exports = {"id":"s4-q1a","text":"Do you use a web browser to access the internet for any reason (work/study/personal)?","multiselect":false,"options":[{"id":"s4-q1a-a1","text":"Yes","capability":1,"access":2,"next":"s4-q2","focusarea":[2,0,0,0,0]},{"id":"s4-q1a-a2","text":"No","next":"s5-q1","capability":-2,"access":-3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s4-q1a.json
// module id = 918
// module chunks = 32